import { Tooltip, Typography, TypographyProps } from '@mui/material';
import React from 'react';

export interface ColorCodedTypographyProps extends TypographyProps {
	value: number;
	prefix?: string;
	suffix?: string;
	hideIfZero?: boolean;
	tooltip?: string;
}
const ColorCodedTypography = (props: ColorCodedTypographyProps) => {
	const { value, prefix, suffix, hideIfZero, tooltip, children, ...typographyProps } = props;

	if (value === 0 && hideIfZero) return null;

	return (
		<Tooltip title={tooltip ?? ''}>
			<Typography
				{...typographyProps}
				sx={{
					color: (theme) =>
						value === 0
							? theme.palette.colors.availabilityNone.dark
							: theme.palette.colors.availabilityGood.dark,
					textDecoration: !!tooltip ? 'underline' : 'none',
					...typographyProps.sx,
				}}
			>
				{prefix ?? ''}
				{children ? children : value}
				{suffix ?? ''}
			</Typography>
		</Tooltip>
	);
};

export default ColorCodedTypography;
